import { render, staticRenderFns } from "./MobileFrame.vue?vue&type=template&id=43f75572&scoped=true"
import script from "./MobileFrame.vue?vue&type=script&lang=js"
export * from "./MobileFrame.vue?vue&type=script&lang=js"
import style0 from "./MobileFrame.vue?vue&type=style&index=0&id=43f75572&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43f75572",
  null
  
)

export default component.exports